export default __webpack_public_path__ + "static/media/290-mark.aea81ec5.svg";